import { Grid } from "@material-ui/core";
import { Fragment, useCallback } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import styled from "styled-components";
import {
  DangerButton,
  PrimaryButton,
} from "../../../../../../../components/button";
import { TextField } from "../../../../../../../components/forms/text";
import { Icon } from "../../../../../../../components/icons";
import { GridItem } from "../../../../../../../components/layout";

export interface ISocialMediaLinksProps {}

const TrashIcon = styled(DangerButton)`
  width: 2.5em;
  height: 2.5em;
  padding: 0;
  min-width: 0;
`;

export function SocialMediaLinks() {
  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = useFormContext();

  const value = useWatch({
    control,
    name: `socialMediaLinks`,
  }) as Array<string>;

  const append = useCallback(
    () => setValue(`socialMediaLinks`, [...value, ""]),
    [value, setValue]
  );
  const remove = useCallback(
    (j: number) =>
      setValue(
        `socialMediaLinks`,
        value.filter((_, i) => i !== j)
      ),
    [value, setValue]
  );

  return (
    <Grid container spacing={1}>
      {value.map((val, i) => (
        <Fragment key={i}>
          <Grid item xs={9}>
            <TextField
              fullWidth
              {...register(`socialMediaLinks[${i}]`)}
              error={!!errors[`socialMediaLinks[${i}]`]}
              helperText={errors[`socialMediaLinks[${i}]`]?.message}
            />
          </Grid>
          <GridItem xs={3}>
            <TrashIcon onClick={() => remove(i)}>
              <Icon type="trash" />
            </TrashIcon>
          </GridItem>
        </Fragment>
      ))}
      <Grid item xs={12}>
        <PrimaryButton onClick={append}>Add</PrimaryButton>
      </Grid>
    </Grid>
  );
}
